const icon = require('vue-svgicon');
icon.register({
    'arrow': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16c8.823 0 16-7.177 16-16S24.822 0 16 0zm0 31.17C7.635 31.17.83 24.365.83 16S7.635.83 16 .83 31.17 7.635 31.17 16 24.365 31.17 16 31.17z"/><path pid="1" d="M17.292 11.491l4.928 4.393H9.061v.83H22.22l-4.928 4.394.552.619 6.088-5.428-6.088-5.428z"/>`,
    },
});
